import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface YesNoDialogData {
  message: string;
  yesLabel?: string;
  noLabel?: string;
}

@Component({
  template: `
    <div class="flex gap-4 p-2">
      <i class="pi pi-exclamation-triangle text-3xl" style="color: var(--p-primary-500); flex-shrink: 0; margin-top: 2px;"></i>
      <div class="text-base leading-relaxed" [innerHTML]="data.message"></div>
    </div>
    <div class="flex justify-end gap-2 mt-4 pt-3" style="border-top: 1px solid var(--p-surface-200);">
      <button (click)="close(false)" pButton type="button" class="p-button-raised p-button-secondary">{{ data.noLabel || 'No' }}</button>
      <button (click)="close(true)" pButton type="button" class="p-button-raised">{{ data.yesLabel || 'Yes' }}</button>
    </div>
  `,
  standalone: false,
})
export class YesNoDialogComponent {
  data: YesNoDialogData;

  constructor(dialogConfig: DynamicDialogConfig<YesNoDialogData>, private ref: DynamicDialogRef) {
    this.data = dialogConfig.data || { message: '' };
  }

  close(result: boolean) {
    this.ref.close(result);
  }
}
